import React, { useState, useEffect } from 'react';
import { submitMockTest } from '../../../../actions/mock-test';
import { useDispatch } from 'react-redux';
import KatexViewer from '@/helpers/Katex';

//fill in the blanks template
const Template5 = ({
  question,
  section,
  model,
  title,
  context,
  scrollToQ,
  setAns,
  answers,
  setAnswer,
}) => {
  const dispatch = useDispatch();
  //const [answers, setAnswer] = useState({})
  const [newcontext, setContext] = useState('');
  const [ansObj, setAnsObj] = useState({
    group_answer: null,
    text: '',
    model_id: model,
    section_id: section,
    question_id: question.id,
  });

  const updateAnswer = (e, q) => {
    setAnswer((answers) => {
      return { ...answers, [q.id]: (e.target as HTMLInputElement).value };
    });
    let id = parseInt((e.target as HTMLInputElement).getAttribute('data-group-id'));
    let questionId = parseInt(
      (e.target as HTMLInputElement).getAttribute('question-id')
    );
    let sectionId = parseInt(
      (e.target as HTMLInputElement).getAttribute('section-id')
    );
    // console.log("question id", question.id);

    setAnsObj({
      model_id: model,
      section_id: sectionId,
      question_id: questionId,
      group_answer: id,
      text: (e.target as HTMLInputElement).value,
    });
    // }
  };

  useEffect(() => {
    let obj = {};
    let id = ansObj.group_answer;
    // console.log("Answer obj", ansObj)
    if (id == null) return;
    if (answers.find((o) => o.group_answer == id)) {
      // let obj = answers.find(o => o.group_answer == id);
      let idx = answers.findIndex((o) => o.group_answer == id);
      //obj.answer_id= id
      setAns((prevans) => [
        ...prevans.slice(0, idx),
        { ...prevans[idx], text: ansObj.text },
        ...prevans.slice(idx + 1),
      ]);

      dispatch(
        submitMockTest(
          JSON.stringify({
            model: model,
            section: ansObj.section_id,
            answer: id,
            question: ansObj.question_id,
            group_answer: ansObj.group_answer,
            text: ansObj.text,
            is_correct: 'true',
          })
        )
      );
    } else {
      // console.log("new answers,  ", answers)
      obj = {
        model_id: model,
        section_id: section,
        question_id: question.id,
        group_answer: id,
        text: ansObj.text,
      };
      setAns((prevans) => [...prevans, obj]);
    }
  }, [ansObj]);
  useEffect(() => {
    var elems = document.getElementsByClassName('learnsic-question');
    Array.from(elems).map((q, i) => {
      q.setAttribute('ref', 'test');
      elems[i].addEventListener(
        'change',
        function (e) {
          updateAnswer(e, q);
        },
        false
      );
    });
  }, []);
  useEffect(() => {
    try {
      var elmnt = document.getElementById('q-' + scrollToQ);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    } catch (err) {
      // console.log('doesnot exist');
    }
    //window.scroll(0,findPos(elmnt));
  }, [scrollToQ]);
  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          <div className="number" id={`q-${question.q_no}`}>
            {question.q_no}
          </div>
        </div>
      </div>
      <div className="type_blank">
        {question?.instruction ? (
          <div className="d-flex instruction-question">
            <div
              dangerouslySetInnerHTML={{ __html: question?.instruction }}
              className="px-2"
            />
          </div>
        ) : (
          ''
        )}
        <div className="question-title">
          <span>
            {question?.has_expression ? <KatexViewer text={title} /> : title}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Template5;
